/**
 * マニフェスト １次２次紐付け 新規作成前バリデーション
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/linkages/verifications`

const manifest_linkage_verification = {
  namespaced: true,
  actions: {
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    }
  },
}

export default manifest_linkage_verification

